import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Text as ChakraText,
} from '@chakra-ui/react'
import type { FieldProps } from 'formik'
import { Field } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'
import type { SourcesResponse } from '../../interfaces'
import { InfoPopover } from './InfoPopover'

interface Props {
  name: string
  placeholder?: string
  label: string
  info?: string
  description?: string
  required: boolean | undefined
  isDisabled?: boolean
}

export const OriginFormInput = ({
  name,
  placeholder,
  label,
  info,
  description,
  required,
  isDisabled,
}: Props): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <Field name={name}>
      {({ field, form }: FieldProps<string, SourcesResponse>) => (
        <FormControl
          isInvalid={Boolean(form.errors[name] && form.touched[name])}
          isDisabled={isDisabled}
          isRequired={required}
        >
          <Flex alignItems="baseline">
            <FormLabel htmlFor={name}>{t(label)}</FormLabel>
            {info && <InfoPopover info={info} />}
          </Flex>
          {description && (
            <ChakraText paddingBottom="0.8em">{t(description)}</ChakraText>
          )}
          <Input
            {...field}
            id={name}
            placeholder={placeholder}
            onChange={form.handleChange}
          />
          <FormErrorMessage marginBottom="-2.0408em">
            {form.errors[name]}
          </FormErrorMessage>
        </FormControl>
      )}
    </Field>
  )
}
